// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__t4VDs","load8":"Spinner_load8__COd7Y","Loader--white":"Spinner_Loader--white__nO5hE","Loader--secondary":"Spinner_Loader--secondary__xvD2T"};